import {post} from './walletAxios';
import {parseJwtFromToken} from '../app/utils';

export const AUTH_PATH = '/auth';
export const LOGIN_PATH = AUTH_PATH + '/login';
export const SIGNUP_PATH = AUTH_PATH + '/signup';
export const REFRESH_PATH = AUTH_PATH + '/refresh';

export const LOCAL_STORAGE_ACCESS_TOKEN_KEY = 'accessToken';
export const LOCAL_STORAGE_REFRESH_TOKEN_KEY = 'refreshToken';
export const LOCAL_STORAGE_EXPIRES_IN_KEY = 'expiresIn';
export const LOCAL_STORAGE_USERNAME_KEY = 'username';
export const LOCAL_STORAGE_USER_ID_KEY = 'userId';

export const refreshToken = async (refreshToken = localStorage.getItem(
    LOCAL_STORAGE_REFRESH_TOKEN_KEY)) => {
    return post(`${REFRESH_PATH}?refreshToken=${refreshToken}`, undefined, false)
        .then(response => {
            saveAuthData(response);
            return response;
        });
};

export const loginByUserName = async (username, password) => {
    const body = {
        username,
        password
    };

    return post(LOGIN_PATH, body, false)
        .then(response => {
            saveAuthData(response);
            return response;
        });
};

export const signup = async (username, password) => {
    const body = {
        username,
        password
    };

    return post(SIGNUP_PATH, body, false)
        .then(response => {
            saveAuthData(response);
            return response;
        });
};

function saveAuthData(response) {
    if (!response?.accessToken) {
        return;
    }

    localStorage.setItem(LOCAL_STORAGE_ACCESS_TOKEN_KEY, response.accessToken);
    localStorage.setItem(LOCAL_STORAGE_REFRESH_TOKEN_KEY, response.refreshToken);
    localStorage.setItem(LOCAL_STORAGE_EXPIRES_IN_KEY, response.expiresIn);

    let tokenData = parseJwtFromToken(response.accessToken);

    tokenData.userId && localStorage.setItem(LOCAL_STORAGE_USER_ID_KEY, tokenData.userId);
    tokenData.username && localStorage.setItem(LOCAL_STORAGE_USERNAME_KEY, tokenData.username);
}
